<template>
  <div v-if="item">
    <div class="mb-3">
        <span class="text-muted">Date Completed:</span> {{ $filters.date(item.completed_at, 2) }}
    </div>
    <div class="row mb-4 g-4">
        <div class="col-12">
            <div class="row g-3 mb-3 align-items-center">
                <div class="col-lg-6">
                    <div class="card d-inline-flex card-body p-2">
                        <div class="avatar-group mb-2">
                            <div class="avatar-group-item material-shadow-none " v-b-tooltip.hover
                                title="BVN image">
                                <div style="width: 7rem; height: 7rem;"
                                    class="avatar-lg bg-light rounded-circle cursor-pointer">
                                    <img @click="showProfileImg(item.bvn_image)" :src="item.bvn_image"
                                        alt="" class="rounded-circle img-fluid h-100 w-100"
                                        style="object-fit: cover;" />
                                </div>
                            </div>
                            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                                title="Profile image">
                                <div style="width: 7rem; height: 7rem;"
                                    :class="item.bvn_photo_status ? 'border-primary' : 'border-danger'"
                                    class="border border-4 rounded-circle avatar-lg bg-transparent cursor-pointer">
                                    <img @click="showProfileImg(item.profile_image)"
                                        :src="absoluteUrl(item.profile_image)" alt=""
                                        class="rounded-circle img-fluid h-100 w-100"
                                        style="object-fit: cover;" />
                                </div>
                            </div>
                        </div>
                        <small class="text-center">BVN photo status</small>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card d-inline-flex card-body p-2">
                        <div class="avatar-group mb-2">
                            <div class="avatar-group-item material-shadow-none " v-b-tooltip.hover
                                title="NIN image">
                                <div style="width: 7rem; height: 7rem;"
                                    class="avatar-lg bg-light rounded-circle cursor-pointer">
                                    <img @click="showProfileImg(item.nin_image)" :src="item.nin_image"
                                        alt="" class="rounded-circle img-fluid h-100 w-100"
                                        style="object-fit: cover;" />
                                </div>
                            </div>
                            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                                title="Profile image">
                                <div style="width: 7rem; height: 7rem;"
                                    :class="item.nin_photo_status ? 'border-primary' : 'border-danger'"
                                    class="border border-4 rounded-circle avatar-lg bg-transparent cursor-pointer">
                                    <img @click="showProfileImg(item.profile_image)"
                                        :src="absoluteUrl(item.profile_image)" alt=""
                                        class="rounded-circle img-fluid h-100 w-100"
                                        style="object-fit: cover;" />
                                </div>
                            </div>
                        </div>
                        <small class="text-center">NIN photo status</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row g-2 mb-2">
                        <div class="col-sm-6"><span class="text-muted">All Verification Passed:</span></div>
                        <div class="col-sm-6 fw-bold">
                            <span v-if="item.all_verification_passed" class="badge bg-primary"> PASSED
                            </span>
                            <span v-else class="badge bg-danger"> FAILED </span>
                        </div>
                    </div>
                    <div class="row g-2 mb-2">
                        <div class="col-sm-6"><span class="text-muted">Min Verification Passed:</span></div>
                        <div class="col-sm-6 fw-bold">
                            <span v-if="item.min_verification_passed" class="badge bg-primary"> PASSED
                            </span>
                            <span v-else class="badge bg-danger"> FAILED </span>
                        </div>
                    </div>
                    <div v-if="item.manual_check_passed" class="row g-2">
                        <div class="col-sm-6"><span class="text-muted">Manual Check Remark:</span></div>
                        <div class="col-sm-6 fw-bold">
                            <span v-if="item.manual_check_passed" class="badge bg-primary">
                                PASSED </span>
                            <span v-else class="badge bg-danger"> FAILED </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row g-2 mb-2">
                        <div class="col-sm-5"><span class="text-muted">BVN status:</span></div>
                        <div class="col-sm-7 fw-bold">
                            <span v-html="statusBadge(item.bvn_status)"></span>
                        </div>
                    </div>
                    <div class="row g-2 mb-2">
                        <div class="col-sm-5"><span class="text-muted">NIN status:</span></div>
                        <div class="col-sm-7 fw-bold">
                            <span v-html="statusBadge(item.nin_status)"></span>
                        </div>
                    </div>
                    <div class="row g-2 mb-2">
                        <div class="col-sm-5"><span class="text-muted">Bank account status:</span></div>
                        <div class="col-sm-7 fw-bold">
                            <span v-html="statusBadge(item.bank_account_status)"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table
                    class="table table-borderless table-sm table-centered align-middle table-nowrap mb-0">
                    <thead>
                        <tr>
                            <th>BVN Checked</th>
                            <th>Profile Info</th>
                            <th>BVN Info</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody class="border-0">
                        <tr>
                            <td>
                                <span> First name</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.profile_first_name }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.bvn_first_name }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.bvn_first_name_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span> Last name</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.profile_last_name }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.bvn_last_name }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.bvn_last_name_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span> Date of birth</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ $filters.date(item.profile_date_of_birth)
                                    }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ $filters.date(item.bvn_date_of_birth)
                                    }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.bvn_date_of_birth_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr>
            <div class="table-responsive">
                <table
                    class="table table-borderless table-sm table-centered align-middle table-nowrap mb-0">
                    <thead>
                        <tr>
                            <th>NIN Checked</th>
                            <th>Profile Info</th>
                            <th>NIN Info</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody class="border-0">
                        <tr>
                            <td>
                                <span> First name</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.profile_first_name }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.nin_first_name }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.nin_first_name_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span> Last name</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.profile_last_name }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ item.nin_last_name }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.nin_last_name_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span> Date of birth</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ $filters.date(item.profile_date_of_birth)
                                    }}</span>
                            </td>
                            <td>
                                <span class="text-uppercase">{{ $filters.date(item.nin_date_of_birth)
                                    }}</span>
                            </td>
                            <td>
                                <p class="text-muted mb-0">
                                    <span v-if="item.nin_date_of_birth_status"
                                        class="badge bg-success">PASSED</span>
                                    <span v-else class="badge bg-danger">FAILED</span>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12">
            <div class="row g-4">
                <div v-if="item.profile_full_name" class="col-md-6 col-lg-4">
                    <label class="small"> Profile full name: </label>
                    <div class="mb-0">
                        {{ item.profile_full_name }}
                    </div>
                </div>
                <div v-if="item.bvn_full_name" class="col-md-6 col-lg-4">
                    <label class="small"> BVN full name: </label>
                    <div class="mb-0">
                        {{ item.bvn_full_name }}
                    </div>
                </div>
                <div v-if="item.nin_full_name" class="col-md-6 col-lg-4">
                    <label class="small"> NIN full name: </label>
                    <div class="mb-0">
                        {{ item.nin_full_name }}
                    </div>
                </div>
                <div v-if="item.bvn_error" class="col-md-6 col-lg-4">
                    <label class="small"> BVN error: </label>
                    <div class="mb-0 small">
                        {{ item.bvn_error }}
                    </div>
                </div>
                <div v-if="item.nin_error" class="col-md-6 col-lg-4">
                    <label class="small"> NIN error: </label>
                    <div class="mb-0 small">
                        {{ item.nin_error }}
                    </div>
                </div>
                <div v-if="item.bank_account_error" class="col-md-6 col-lg-4">
                    <label class="small">Bank account error: </label>
                    <div class="mb-0 small">
                        {{ item.bank_account_error }}
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
            default: null
        }
    }
}
</script>

<style>

</style>